
export const interpreterConstants = {
    SAGA_INTERPRET_BOM_INPUT: "SAGA_INTERPRET_BOM_INPUT",
    }

export const  sagaInterpretBomInputAction = (bomData: any[]) => {
    return { 
        type: interpreterConstants.SAGA_INTERPRET_BOM_INPUT,
        payload: { bomData },
    }
}


